import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconVerySatisfiedFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function f(e, t, r, u, _, a) {
  return d(), l("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--very-satisfied-filled"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Very Satisfied Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.438 6A5.437 5.437 0 1 0 .563 6a5.437 5.437 0 0 0 10.874 0Zm-3.5-1.5a.438.438 0 0 0-.438-.438h-.005a.437.437 0 1 0 0 .875H7.5a.437.437 0 0 0 .438-.437Zm-3 0a.438.438 0 0 0-.438-.438h-.005a.437.437 0 1 0 0 .875H4.5a.437.437 0 0 0 .438-.437Zm4.396 1.718A.437.437 0 0 0 9 6.063H3a.437.437 0 0 0-.431.51A3.437 3.437 0 0 0 6 9.438a3.437 3.437 0 0 0 3.431-2.865.437.437 0 0 0-.097-.355Zm-.907.72a2.562 2.562 0 0 1-2.42 1.625h-.014a2.562 2.562 0 0 1-2.42-1.626h4.853Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const S = /* @__PURE__ */ o(c, [["render", f]]);
export {
  S as default
};
//# sourceMappingURL=very-satisfied-filled.js.map
